import './Footer.css';

export default function Footer() {
    return (
        <div className="FooterStyle">
            <p>
                &copy; {new Date().getFullYear()} Torna Campsites | All rights reserved
            </p>
        </div>
    );
}
